/**
 * Footer component for the menu page
 */
import { Button } from '@/components/ui'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-border bg-background mt-12 sm:mt-16">
      <div className="container mx-auto px-3 sm:px-4 py-8 sm:py-10 max-w-7xl">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
          {/* Copyright */}
          <div className="text-sm text-muted-foreground text-center sm:text-left">
            &copy; {currentYear} Restaurant. All rights reserved.
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Button variant="link" className="h-auto p-0 text-sm text-muted-foreground hover:text-foreground">
              Privacy Policy
            </Button>
            <Button variant="link" className="h-auto p-0 text-sm text-muted-foreground hover:text-foreground">
              Terms of Service
            </Button>
            <Button variant="link" className="h-auto p-0 text-sm text-muted-foreground hover:text-foreground">
              Contact
            </Button>
          </div>
        </div>
      </div>
    </footer>
  )
}
